<template>
  <div class="gap-events">
    <event-teaser
      :type="type"
      :date="gapDate"
      :position="position"
      extended
    />
  </div>
</template>

<script>
import eventTeaser from './eventTeaser.vue'

export default {
  name: 'CGapEvents',

  components: {
    eventTeaser
  },

  props: {
    type: {
      type: String,
      required: true
    },
    position: {
      type: String,
      default: 'gaplist_top'
    }
  },

  computed: {
    gapDate () {
      return this.$store.state.arrivalTable[this.type].date
    }
  }
}
</script>
